<template>
  <div :class="flexOption">
    <button
      :class="classButton"
      :disabled="disabled"
      :type="type"
      @click="$emit('buttonClick', $event)"
    >
      <slot name="ButtonContent">{{ label }}</slot>
    </button>
  </div>
</template>
<script>
export default {
  name: "classicbutton",
  props: {
    label: {
      type: String,
      required: false,
      default: "- ? -"
    },
    classButton: {
      type: String,
      required: false,
      default: "button primaryButton"
    },
    flexOption: {
      type: String,
      required: false,
      default: "flex-button"
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      requrired: false,
      default: "button"
    }
  }
};
</script>